export default "__VITE_ASSET__C_iIO13i__"